export default "__VITE_ASSET__2UZMnPZY__"